import { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useRole } from '../../../Hooks/Role';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { SportRuleContext } from '../Context/SportRuleContext';

const SportRule = () => {
  const context = useContext(SportRuleContext);
  const { can } = useRole();
  const { get, destroy, put } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState({
    id: undefined,
    loading: false,
  });

  useEffect(() => {
    const getData = async () => {
      await getSportRules();
    };
    getData();
  }, [search]);

  const getSportRules = async () => {
    setLoading(true);
    await get(
      `/sport-rule${search}`,
      (res) => {
        context.sportRules = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/sport-rule/${id}`,
      (res) => {
        success(
          `حکم "${modalRemoveObject?.competition_name}" با موفقیت حذف شد.`,
        );
        setRemoveLoading(false);
        setModalIsOpen(false);
        getSportRules();
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  const confirm = async (item) => {
    setConfirmLoading({
      id: item?.id,
      loading: true,
    });
    await put(
      `/sport-rule/${item?.id}`,
      {
        status: item?.status == 0 ? 1 : item?.status == 1 ? 2 : 1,
      },
      (res) => {
        setConfirmLoading({
          id: item?.id,
          loading: false,
        });
        getSportRules();
        success('عملیات با موفقیت انجام شد');
      },
      (err) => {
        setConfirmLoading({
          id: item?.id,
          loading: false,
        });
        error('خطا در تایید/رد حکم');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست حکم های قهرمانی کشور '
          createBtnTitle='افزودن حکم'
          createPath='/sport-rule/create'
        />
        <Datatable
          data={context.sportRules?.data}
          editUrl='/sport-rule/edit'
          meta={context.sportRules?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath={`/sport-rule`}
          columns={['نام مسابقه', 'رشته', 'تاریخ', 'وضعیت', 'تایید/رد']}
          rows={[
            { name: 'competition_name', type: 'string' },
            { name: 'sport.title', type: 'relation', relType: 'string' },
            { name: 'date', type: 'date' },
            {
              name: 'status',
              type: 'confirm',
              active: {
                0: 'در انتظار بررسی',
                1: 'تایید شده',
                2: 'رد شده',
              },
              badgeClass: {
                0: 'badge-warning',
                1: 'badge-success',
                2: 'badge-danger',
              },
            },
            can('Super Admin')
              ? {
                  title: 'تایید/رد',
                  type: 'action',
                  action: (item) => confirm(item),
                  loading: confirmLoading,
                }
              : {},
          ]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف حکم "${modalRemoveObject?.competition_name}" مطمئن هستید ؟`}
      />
    </>
  );
};

export default SportRule;
